import CustomComponent from '../CustomComponent';

export class IconComponent extends CustomComponent {
	static key = 'lta-icon';

	static get observedAttributes() {
		return ['sprite-icon', 'width', 'height', 'fill', 'aria-hidden', 'classes'];
	}

	render() {
		const {
			spriteIcon = '',
			width = '1em',
			height = '1em',
			fill = 'currentColor',
			ariaHidden = 'true',
			classes = ''
		} = this.props;

		const classNames = ['lta-icon', 'js-lta-text-input--btn-icon', classes];

		return `
            <svg 
                class="${classNames}" 
                width="${width}" 
                height="${height}" 
                style="color:${fill};" 
                fill="${fill}" 
                alt="${spriteIcon}" 
                aria-hidden="${ariaHidden}" 
                role="img">
                <use xlink:href="/static/images/icons/lta-icons.svg#${spriteIcon}"></use>
            </svg>
        `;
	}
}

export default IconComponent;
